module.exports = __webpack_public_path__ + "static/media/17UN-Women8.e74f926d.jpg";